import { render, staticRenderFns } from "./Rating.vue?vue&type=template&id=7e04936c&"
import script from "./Rating.vue?vue&type=script&lang=ts&"
export * from "./Rating.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports